// extracted by mini-css-extract-plugin
module.exports = {"first-time-tip":"textInstruction_first-time-tip__BM8AN"};